import React, {Component} from 'react';
import SearchDetailHeaderCarousel from "./SearchDetailHeaderCarousel";
import SearchDetailHeaderHeadline from "./SearchDetailHeaderHeadline";
import SearchDetailContent from "./SearchDetailContent";
import axios from "axios/index";
import {  isBrowser, isMobile} from "react-device-detect";



class SearchDetail extends Component{
    constructor(props){
        super(props);
        this.myRef = React.createRef()

        this.state = {
            result:[],
            obrazky: [],
            categories:[],
            tags:[],
        }

        axios.get('https://mportalsystem2.btect.sk/api/getlist/' + this.props.id)
            .then(res => {
                const data = res.data[0];
                this.setState({ obrazky: data.listingimages });
                this.setState({ result: data });
                this.setState({ categories: data.categories });
                this.setState({ tags: data.tags });
                window.scrollTo(0,0);
            });
    }
    componentDidMount(){
        window.scrollTo(0,0);
    }


    render(){
        if(isMobile) {
            return (
                <div className="searchdetail" ref={this.myRef}>
                    <SearchDetailHeaderHeadline result={this.state.result} setSearchBack={this.props.setSearchBack} result={this.state.result}/>
                    <SearchDetailContent setSearchDefs={this.props.setSearchDefs} ide={this.props.id}
                                         tags={this.state.tags} categories={this.state.categories}
                                         result={this.state.result}/>
                    <SearchDetailHeaderCarousel categories={this.state.categories} obrazky={this.state.obrazky}
                                                result={this.state.result}/>
                </div>
            );
        }
        else{
            return (
                <div className="searchdetail" ref={this.myRef}>
                    <SearchDetailHeaderCarousel categories={this.state.categories} obrazky={this.state.obrazky}
                                                result={this.state.result}/>
                    <SearchDetailHeaderHeadline setSearch={this.props.setSearch} setSearchBack={this.props.setSearchBack} result={this.state.result}/>
                    <SearchDetailContent setSearchDefs={this.props.setSearchDefs} ide={this.props.id}
                                         tags={this.state.tags} categories={this.state.categories}
                                         result={this.state.result}/>

                </div>
            );
        }
    }
}
export default SearchDetail;